import React from "react";
import Select from "react-select";
import Skeleton from "@mui/material/Skeleton";
import FormControl from "@mui/material/FormControl";

const SelectInput = ({
  value,
  label,
  onChange,
  options,
  placeholder = "Select",
  maxWidth = "none",
  name,
  error = false,
  loading = false,
  dropdownMaxHeight = 300,
  customStyle = {},
  isDisabled = false,
  menuIsOpen = undefined,
  onMenuOpen = undefined,
  onMenuClose = undefined,
}) => {
  const selectedOption = options.find((opt) => opt.value == value) || null;

  const handleChange = (selected) => {
    onChange?.({
      target: {
        name,
        value: selected ? selected.value : "",
      },
    });
  };

 const styles = {
  control: (base, state) => ({
    ...base,
    borderRadius: 4,
    height: 40,
    minHeight: 40,
    maxWidth: maxWidth,
    borderColor: error ? "red" : state.isFocused ? "#aac7e7" : "#C0C0C0",
    boxShadow: state.isFocused ? "0 0 0 1px #aac7e7" : "none",
    fontFamily: "Geist, sans-serif",
    fontSize: 16,
    ...customStyle,
  }),
  placeholder: (base) => ({
    ...base,
    color: "#999",
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: dropdownMaxHeight,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 2000,
    position: "fixed", // ✅ Ensures it floats above, not relative to other layout
  }),
};


  if (loading) {
    return (
      <FormControl fullWidth size="small">
        <Skeleton
          variant="rectangular"
          height={40}
          width="100%"
          sx={{ borderRadius: 1 }}
        />
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Select
        isDisabled={isDisabled}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        isClearable
        styles={styles}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        menuPosition="absolute"
        menuIsOpen={menuIsOpen}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
      />
    </FormControl>
  );
};

export default SelectInput;
